import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';

export default function WpContainer({children}) {
    return <>
        <link rel="stylesheet" href={"/homepage-app/wpStyles.css"}/>
        {children}
    </>
}